module.exports = __webpack_public_path__ + "static/img/a7070xgri_pop9.e82950b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/images/a7070xgri_pop9.jpg
// module id = TZJb
// module chunks = 0